import React, { useEffect } from "react";

const UseTitle = (title) => {
  useEffect(() => {
    document.title = `${title} | Matir Maya Eco Resort`;
  }, [title]);
};

export default UseTitle;
